import { Switch, Textbox } from "@mcleod/components";
import { AutogenLayoutComments } from "./autogen/AutogenLayoutComments";

export class Comments extends AutogenLayoutComments {

    switchCopyToOrderOnChange(event) {
        const switchCopyToOrder = event.target as Switch;
        this.textboxOrderCommentType.required = switchCopyToOrder.checked && this.panelOrderFields.visible;
        if (!switchCopyToOrder.checked)
            this.textboxOrderCommentType.text = null;
    }

    commentTypeBeforeLookup(event) {
        // filter out the comment types that are not active
        const searchFilter = { text_search: (event.target as Textbox).text };
        searchFilter["is_active"] = "Y";
        event.filter = searchFilter;
    }
}
